import { Injectable } from "@angular/core";

@Injectable()
export class MasterscreenConstantsService {
  // Serach type for User
  public static UserType = {
    Employee: "Employee"
  };

  // Constants Message for success and error
  public static Message = {
    SuccessObservation: "Observation Details submitted successfully",
    UpdateObservation: "Observation Details updated successfully",
    DeleteConfrmationObservation:
      "Are you sure you want to delete this Observation Type? Yes / No",
    DeleteObservation: "Observation Type deleted successfully",
    SelectConfirmationForActive:
      "If you make Observation Type inactive," +
      " " +
      "then it will not appear in any forms for selection. Do you want to continue ?",
    SuccessHazardDetails: "Hazard Details submitted successfully",
    UpdateHazardDetials: "Hazard Details updated successfully",
    UpdateObservationCategory: "Observation Category updated successfully",
    SuccessObservationCategory: "Observation Category submitted successfully",
    DeleteConfrmationObservationCategory:
      "Are you sure you want to delete this Observation Category? Yes / No",
    DeleteObservationCategory: "Observation Category deleted successfully",
    SubmitConfigurationSuccessfully:
      "Configuration details submitted successfully",
    DeleteUserRoleMapping: "{0} is removed from the {1}",
    DeleteConfirmationRoleMapping:
      "Do you want to remove an employee from {0} Role?  (Y / N)",
    RaiseCountExceededForHseAdviser:
      "Sorry! cannot delete the role because {0} has {1} request pending with him/her." +
      "{2} can be removed only after his / her pending tasks are completed",
    SucceessRoleMapping: "User role mapping completed",
    SelectConfirmationForActiveObsCat:
      "If you make Observation Category inactive," +
      " " +
      "then it will not appear in any forms for selection. Do you want to continue ?"
  };

  // API URl for configuration screen
  public static APIURL = {
    GetRoleMasterDetails: "api/hse/configuration/getRoleMasterDetails",
    RoleMaster: "api/hse/configuration/saveRoleMasterDetails",
    getPermissionsDetails: "api/hse/configuration/getpermissionsdetails",
    RolePermission: "api/hse/configuration/rolePermission",
    GetRolePermissions: "api/hse/configuration/getpermissionsforroleid",
    getCompanyDetails: "api/hse/configuration/getcompanydetails",
    getProjectDetails: "api/hse/configuration/getprojectdetails",

    
    
    saveKPIMaster: "api/hse/configuration/saveKPIMaster",
    getKPIMasterList: "api/hse/configuration/getKPIMasterList",

    getLocationDetails: "api/hse/configuration/getlocationdetails",
    getPrerequisiteDetails: "api/hse/configuration/getPrerequisiteDetails",
    getSourceConfigurationDetails:
      "api/hse/configuration/getSourceConfigurationDetails",
    getSectionDetails: "api/hse/configuration/getsectiondetails",
    saveCompanyDetails: "api/hse/configuration/savecompanydetails",
    saveProjectDetails: "api/hse/configuration/saveprojectdetails",
    saveLocationDetails: "api/hse/configuration/savelocationdetails",
    saveSectionDetails: "api/hse/configuration/savesectiondetails",
    saveSourceConfigurationDetails:
      "api/hse/configuration/savesourceconfigurationdetails",
    saveConfigurationDetails:
      "api/common/configuration/saveConfigurationDetails",
    saveContractorDetails: "api/common/configuration/saveuserdetails",
    getUserDetails: "api/common/configuration/getuserdetails",
    getAllContractors: "api/common/configuration/getallcontractors",
    deleteContractorDetails: "api/common/configuration/deleteuserdetails",
    saveHazardDetails: "api/hse/configuration/savehazarddetails",
    getHazardDetails: "api/hse/configuration/gethazarddetails",
    deleteHazardDetails: "api/hse/configuration/deletehazarddetails",
    saveObservationTypeDetails:
      "api/hse/configuration/saveobservationtypedetails",
    deleteObservationTypeDetails:
      "api/hse/configuration/deleteobservationtypedetails",
    getObservationTypeDetails:
      "api/hse/configuration/getobservationtypedetails",
    getIsObservationConfigurationCompleted:
      "api/hse/configuration/getisobservationconfigurationcompleted",
    getObservationCategoryDetails:
      "api/hse/configuration/getobservationcategorydetails",
    saveObservationCategoryDetails:
      "api/hse/configuration/saveobservationcategorydetails",
    deleteObservationCategoryDetails:
      "api/hse/configuration/deleteobservationcategorydetails",
    getNoOfRoleAssignedToUser:
      "api/common/configuration/getnoofroleassignedtouser",
    saveUserRoleMapping: "api/common/configuration/saveuserrolemapping",
    saveUserActivityDetails: "api/common/configuration/saveUserActivityDetails",
    getUserRoleMappingDetails: "api/hse/configuration/getuserrolmappingdetails",
    deleteUserRoleMappingDetails:
      "api/hse/configuration/deleteuserrolemappingdetails",
    getRaiseRequestCountForUserId:
      "api/hse/configuration/getraiserequestcountforuserId",
    forgetPassword: "api/common/send/forgetpassword",
    GetTreeDataForUser: "api/hse/getunittreeForUser",
    GetAllTreeData: "api/hse/getunittree",

    GetEmployeesForUnit: "api/hse/getemployeesforunit",
    SaveUnit: "api/hse/saveunit",
    GetUnitTypes: "api/hse/getunittypes",
    DeActivateUnit: "api/hse/deactivateunit",
    DeleteUnitContactInfo: "api/hse/deleteunitcontactinfo",
    DeleteUnitContractDetails: "api/hse/deleteunitcontractdetails",
    GetContractDetailsForUnit:  "api/hse/GetContractDetailsForUnit",
    SavePermissionMatrixData: "api/hse/configuration/savepermissionmatrixdata",
    GetPermissionMatrixData: "api/hse/configuration/getpermissionmatrixdata",
    GetUnits: "api/hse/getunits",
    getIsActiveUnit: "api/hse/getIsActiveUnit",
    SaveCategoryData: "api/hse/configuration/saveCategoryData",
    GetCategoryDetails: "api/hse/configuration/getCategoryDetails",
    SaveCategoryRule: "api/hse/configuration/saveCategoryRule",
    GetCategoryRule: "api/hse/configuration/getCategoryRule",
    SaveLifeSavingMappingDetails:
      "api/hse/configuration/saveLifeSavingMappingDetails",
    GetLifeSavingMappingDetails:
      "api/hse/configuration/getLifeSavingMappingDetails",
    RemoveUserFromUnit: "api/hse/RemoveUserFromUnit",
    SaveInspectionChecklistConfigurationDetails:
      "api/hse/configuration/saveInspectionChecklistConfigurationDetails",
    GetCheckLists: "api/hse/configuration/getCheckLists",
    GetAllModules: "api/hse/getallmodules",
    savePrerequisiteDetails: "api/hse/configuration/savePrerequisiteDetails",
    savePrerequisiteConfiguration:
      "api/hse/configuration/saveprerequisiteconfiguration",
    RetriveListOfPrerequisiteConfigurationMapping:
      "api/hse/configuration/getListOfPrerequisiteConfigurationMapping",
    getPassTypeData: "api/hse/configuration/getpasstypedetails",
    savePassTypeDetails: "api/hse/configuration/savepasstypedetails",
    getPassTypeDetailsData: "api/hse/configuration/getPassTypeDetailsData",
    getPassTypeCategory: "api/hse/configuration/getPassTypeCategory",
    savePassTypeCategoryMapping:
      "api/hse/configuration/savePassTypeCategoryMapping",
    GetPassTypeCategoryMapping:
      "api/hse/configuration/getPassTypeCategoryMapping",
    RetriveOfPassTypeCategoryDataForChecked:
      "api/hse/configuration/retriveOfPassTypeCategoryDataForChecked",
    GetAllMonitoringMatrixName: "api/hse/configure/getallmonitoringmatrixnames",
    SaveMonitoringMatrixDetails:
      "api/hse/configure/savemonitoringmatrixdetails",
    DeleteCheckListPoint: "api/hse/configure/deletechecklistpoint",
    GetPassTypeDetailsDataForConfiguration:
      "api/hse/configuration/getPassTypeDetailsDataForConfiguration",
    SavePDF: "api/hse/savepdf",
    GetCategoryMappingDetailsByModuleId:
      "api/hse/configuration/getLifeSavingMappingDetailsByModuleId",
    GetDictionaryJSON: "api/hse/configuration/getDictionaryJSON",
    SetDictionaryJSON: "api/hse/configuration/setDictionaryJSON",
    DeleteCheckList: "api/hse/configuration/DeleteCheckList",
    GetPermissionsForOverview: "api/hse/getpermissionsforoverview",
    GetDataForCategoryOverview: "api/hse/getdataforcategoryoverview",
    SaveProcessDetails: "api/hse/saveprocessdetails",
    UpdateUnitTree: "api/hse/updateunittree",
    DeleteUnit: "api/hse/deleteunit",
    DeleteSection: "api/hse/deletesection",
    GetCheckListDetails: "api/hse/getcheckListdetails",
    GetCheckListNames: 'api/hse/getchecklistnames',

    saveEmailConfiguration: "api/hse/configuration/saveEmailConfiguration",
    getEmailConfiguration: "api/hse/configuration/getEmailConfiguration",
    getEmailReceiverType: "api/hse/configuration/getEmailReceiverType",
    
    GetContractDetailsData: 'api/pd/get/getContractDetails',
    saveRiskManagementTool: "api/hse/configuration/saveRiskManagementTool",
    getRiskManagementTool: "api/hse/configuration/getRiskManagementTool",
    saveRiskApprovalLevel: "api/hse/configuration/saveRiskApprovalLevel",
    getRiskApprovalLevel: "api/hse/configuration/getRiskApprovalLevel",
    GetDashboardCount: "api/hse/getCountForDashboard",
    GetDashboardSelectedDetails: "api/hse/getDashboardSelectedDetails",

  };

  // Constants for email notification service
  public static EmailConstants = {
    ConfigurationKey: "ReminderMailDays"
  };

  public static ActiveInActiveStatuses = {
    Active: "Active",
    InActive: "InActive"
  };
  public static Processes = {
    Observation: "Observation",
    Risk: "Risk",
    Incident: "Incident"
  };
  public static ProcesseTypes = {
    Processes: [
      {
        Id: 1,
        Value: "Observation",
        Suffix: "OBS"
      },
      {
        Id: 2,
        Value: "Risk",
        Suffix: "RSK"
      },
      {
        Id: 3,
        Value: "Incident",
        Suffix: "INC"
      },
      {
        Id: 4,
        Value: "Action",
        Suffix: "ACT"
      }
    ]
  };
  public static ModuleConst = {
    DESC: "DESC",
    ASC: "ASC",
    CreatedDate: "Created Date",
    TargetDate: "Target Date",
    SourceId: "Source Id",
    ActivityDate: "Activity Date"
  };
  // Gender details
  GenderList = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" }
  ];
}
